import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import 'react';
import { ReactComponent as ForwardRef } from '../../../../assets/icons/ArrowRightSmall.svg.js';

const Container = styled('div') `
  width: 18px;
  height: 18px;
  margin-right: 4px;
  min-width: 18px;
  min-height: 18px;
  & > svg {
    width: 18px;
    height: 18px;
    color: #7e9ec6;
  }
`;
const ArrowButton = ({ show, expanded, onClick }) => {
    return (jsx(Container, { children: show && (jsx(ForwardRef, { "data-testid": "arrow-button", onClick: onClick, style: {
                transform: `${expanded ? 'rotate(90deg)' : 'rotate(0)'}`,
                transition: 'ease-in .1s',
                cursor: 'pointer',
            } })) }));
};

export { ArrowButton };
//# sourceMappingURL=ArrowButton.js.map
